/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, metric: NonNullable<unknown>, prettyRatio: NonNullable<unknown>, rightChain: NonNullable<unknown> }} Chain_Page_Compare_Left_BetterInputs */



/**
* | output |
* | --- |
* | "{leftChain} {metric} is {prettyRatio} higher than {rightChain} {metric}" |
*
* @param {Chain_Page_Compare_Left_BetterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_left_better = /** @type {((inputs: Chain_Page_Compare_Left_BetterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Left_BetterInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} ${i?.metric} is ${i?.prettyRatio} higher than ${i?.rightChain} ${i?.metric}`)
});